import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isRescheduleModalOpen: false,
};

const slice = createSlice({
  name: "ecommerceViewLabTransaction",
  initialState,
  reducers: {
    rescheduleModal(state) {
      state.isRescheduleModalOpen = !state.isRescheduleModalOpen;
    },
  },
});

export const { reducer } = slice;

export const rescheduleModalChange = () => (dispatch) => {
  dispatch(slice.actions.rescheduleModal());
};

export default slice;

// HOW TO USE 👇

// import {
//   closeModal,
//   openModal,
// } from './slices/modals';
// import { useDispatch, useSelector } from './store';

// ACCESS STATE SLICE
// const {
//   isModalOpen,
// } = useSelector((state) => state.modals);

// TRIGGER DISPATCH / REDUCER FUNCTIONS
//const dispatch = useDispatch();
// dispatch(openModal());
